import { createAction } from '@reduxjs/toolkit';

export const SET_NAV_VISIBLE = 'SET_NAV_VISIBLE';
export const GET_TKB = 'GET_TKB';
export const SET_TKB = 'SET_TKB';
export const GET_WIDGET_PROGRESS = 'GET_WIDGET_PROGRESS';
export const SET_WIDGET_PROGRESS = 'SET_WIDGET_PROGRESS';

export type ITkbData = Array<Record<string, string>>;

export type ITkpData = Array<Record<string, string>>;

export interface ITkbRepsonse {
	code: string;
	data: Array<{ tkb?: ITkbData; tkp?: ITkpData }>;
	message: string;
}
export interface IWidgetProgressResponse {
	code: string;
	data: {
		qtyCurrentProcess: number;
		qtyLoanFunded: number;
		isShowWidgetProcess: boolean;
	};
	message: string;
}

export const setNavHeaderVisibleAction = createAction<boolean>(SET_NAV_VISIBLE);

export const getTkbAction = createAction(GET_TKB);

export const setTkbAction =
	createAction<ITkbRepsonse>(SET_TKB);

export const getWidgetProgressAction = createAction(GET_WIDGET_PROGRESS);

export const setWidgetProgressAction =
	createAction<IWidgetProgressResponse>(SET_WIDGET_PROGRESS);
